import { render, staticRenderFns } from "./ScrollBtn.vue?vue&type=template&id=3d39c725&scoped=true"
var script = {}
import style0 from "./ScrollBtn.vue?vue&type=style&index=0&id=3d39c725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39c725",
  null
  
)

export default component.exports